import styled, { AnyStyledComponent } from 'styled-components';
import COLORS from '../../style/universal.color';
import FONTS from '../../style/fonts';

import { buildButtonStyles } from '../Carousel/carousel.style';

const {
  mlbWhite,
  mlbGrey2,
  mlbGrey3,
  mlbGrey5,
  mlbGrey6,
  mlbGrey7,
  focusedBlue
} = COLORS;



interface DayPickerWrapperProps {
  dark: boolean
}

export const DayPickerWrapper: AnyStyledComponent = styled.div`
  height: 35px;
  overflow-y: hidden;
  position: relative;
  >button {
    &:first-child {
      height: 30px;
      padding-left: 3px;
      ${ buildButtonStyles(17, true) }
      left: 1px;
      transition: none;
      &:focus{
        outline: 1px auto ${focusedBlue};
      }  
      svg {
        height: 18px;
        width: 18px;
      }
    }
    &:last-child {
      height: 30px;
      padding-right: 3px;
      transition: none;
      &:focus{
        outline: 1px auto ${focusedBlue};
      }
      svg {
        height: 18px;
        width: 18px;
      }
      ${ buildButtonStyles(17, false) }
      right: 1px;
    }
    &:disabled {
      svg {
        use {
          symbol {
            path {
              fill: ${ ({dark}: DayPickerWrapperProps) => dark ? mlbGrey6 : mlbGrey2 };
            }
          }
        }
      }
      background-color: transparent;
    }
  }
`;

interface SlideWrapperProps {
  showArrows: boolean;
}

export const SlideWrapper: AnyStyledComponent = styled.div`
  overflow-x: hidden;
  ${({showArrows}: SlideWrapperProps) => showArrows
    ? `
      margin-left: 30px;
      width: calc(100% - 60px);
    ` : '' }
`;

interface SlideProps {
  arraySize: number;
  elementSize: number;
};

export const Slide: AnyStyledComponent = styled.div`
  width: ${({arraySize, elementSize}: SlideProps) => arraySize * elementSize}%;
  overflow-y: hidden;
  >div {
    width: ${({arraySize}: SlideProps) => 100 / arraySize}%;
    display: inline-block;
  }
`;

interface DateSlideProps {
  isSelected: boolean;
  dark: boolean;
  mediumWidth: boolean;
  dateGroupMode: boolean;
  loadingGroup: boolean;
  isLoading: boolean;
};

export const DateSlide: AnyStyledComponent = styled.div`
  font-family: ${ FONTS.primaryFont };
  text-align: center;
  justify-content: center;
  height: 35px;
  font-weight: bold;
  >div {
    margin: auto;
    &:last-child {
      margin-top: 3px;
    }
  }
  button {
    padding: 0px;
    padding-top: 0;
    outline: none;
    height: 30px;
    margin-top: 1px;
    color: ${({isSelected, dark}: DateSlideProps) => 
      isSelected ? (dark ? mlbWhite : mlbGrey7) : mlbGrey3 };
    &:hover {
      background-color: transparent;
    }
    &:focus{
      outline: 1px auto ${focusedBlue};
    }
    div {
      ${({ dateGroupMode }) => !dateGroupMode ? 'text-transform: uppercase;' : ''}
    }
  }
  -webkit-touch-callout: none;
  -webkit-user-select: none;
   -khtml-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  div {
    &:first-child {
      font-size: 11px;
      ${({isLoading}: DateSlideProps) => isLoading ? 'margin-bottom: 4px;' : ''}
    }
    &:last-child {
      font-size: 15px;
      letter-spacing: 0.64px;
      margin-top: ${({loadingGroup}: DateSlideProps) => loadingGroup ? '8px' : '0px'}
    }
  }
`;

export const DisabledDateSlide: AnyStyledComponent = styled(DateSlide)`
  button {
    color: ${({dark}: DateSlideProps) => dark ? mlbGrey5 : mlbGrey2 };
    background-color: transparent;
  }
`

export const InnerSlideWrapper: AnyStyledComponent = styled.div``;
export const InnerDateWrapper: AnyStyledComponent = styled.div``;
export const InnerSlideTextWrapper: AnyStyledComponent = styled.div``;